export default "__VITE_ASSET__CkQdQuge__"